export enum UserDetailScreen {
  MAIN = 'main',
  EMAIL = 'email',
  PASSWORD = 'password',
  API_TOKEN = 'apiToken',
}

export interface UserDetailsTimezone {
  value: number;
  label: string;
}
